export default __webpack_public_path__ + "static/media/no_white.3d0c55c0.svg";